var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-card',{attrs:{"title":_vm.$t((_vm.configLocation + "." + _vm.feature)),"is-full":_vm.wide}},[_c('checkboxes',{attrs:{"value":_vm.checked,"options":_vm.values,"wide":_vm.wide,"feature":_vm.feature},on:{"select":_vm.selectValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }